import RecommendedTopListItem from '@components/containers/RecommendedTopListItem/RecommendedTopListItem';
import React from 'react';
import cn from 'classnames';

import styles from './RecommendedTopList.module.scss';
import Props from './RecommendedTopList.props';

const RecommendedTopList = ({ topLists }: Props) => {
  if (topLists.length <= 0) return null;

  return (
    <div className={cn(styles.RecommendedTopList, 'row')}>
      {topLists.map((list) => (
        <RecommendedTopListItem
          key={list.link.url}
          {...list}
          className={cn(styles.ListItem, 'col-md-4')}
        />
      ))}
    </div>
  );
};

export default RecommendedTopList;
